/* FrescH-Finder-NAS v1 – wendet die im NAS-Backend (FrescH-Finder, Port 8910) gepflegten Daten auf den
 * Tauchcomputer-Finder an: Modelle, Texte/Fragen (5 Sprachen), Fragen-Bilder und Auswertungs-Gewichte.
 *
 * Läuft als deferred Script NACH finder2.js und VOR dessen DOMContentLoaded-Handler. Die Daten liegen als
 * Shop-Metafelder fresch_finder.meta + fresch_finder.teil_N (Base64, gestückelt) inline in der Seite.
 * Jede Unstimmigkeit (fehlender Teil, Länge, Prüfsumme, Struktur) → nichts wird verändert, die Seite läuft
 * unverändert mit finder2-db.js / finder2.js weiter.
 *
 * Dieselbe Datei nutzt das Backend für Vorschau und „Auswertung testen“ (fpScore).
 */
(function (w) {
  "use strict";

  var STD_GEWICHTE = {
    budget: 8, budget_nah: 4, budget_weit: 2, budget_nah_bis: 0.2, budget_weit_bis: 0.5,
    style: 4, display: 3, display_watch_statt_gross: 2, display_gross_statt_watch: 1,
    gas: 4, gas_teil: 2, ccr: 6, airInt: 3, airInt_nice: 2, battery: 2,
    connect: 3, connect_teil: 1, compass: 2, gps: 3, logbook: 3, logbook_teil: 1,
    upd: 3, upd_teil: 1, fmt: 3, fmt_teil: 2, console: 6
  };
  var STD_GRENZEN = { "<250": 299, "250-500": 600, "500-900": 1050 };

  function num(v, d) { v = Number(v); return isFinite(v) ? v : d; }

  function fpBudgetOk(c, b, G) {
    var p = c.p;
    if (b === "<250") return p <= G["<250"];
    if (b === "250-500") return p <= G["250-500"];
    if (b === "500-900") return p <= G["500-900"];
    return true;
  }

  /* 1:1 die Logik von finder2.js score(), nur mit einstellbaren Punkten. Mit den Standardwerten identisch. */
  function fpScore(c, a, W, G) {
    W = W || STD_GEWICHTE; G = G || STD_GRENZEN;
    var s = 0, max = 0, cFmt = c.fmt || "wrist-large";
    var gases = Array.isArray(a.gas) ? a.gas : (a.gas ? [a.gas] : []);
    if ((a.fmt === "console" && cFmt !== "console") ||
        (a.fmt && a.fmt !== "any" && a.fmt !== "console" && cFmt === "console") ||
        (gases.indexOf("ccr-gas") >= 0 && c.g.indexOf("ccr-gas") < 0)) return 0;

    max += W.budget;
    if (!a.budget || fpBudgetOk(c, a.budget, G)) s += W.budget;
    else {
      var limit = G[a.budget] || 9999, over = (c.p - limit) / limit;
      if (over < W.budget_nah_bis) s += W.budget_nah; else if (over < W.budget_weit_bis) s += W.budget_weit;
    }
    if (a.style) {
      var styles = Array.isArray(a.style) ? a.style : [a.style];
      max += W.style;
      var m = styles.filter(function (st) { return c.s.indexOf(st) >= 0; }).length;
      s += Math.round((m / styles.length) * W.style);
    }
    max += W.display;
    if (a.display === "any" || c.d === a.display) s += W.display;
    else if (a.display === "color-watch" && c.d === "color-large") s += W.display_watch_statt_gross;
    else if (a.display === "color-large" && c.d === "color-watch") s += W.display_gross_statt_watch;
    if (a.gas) {
      var gl = { air: 1, nitrox: 2, trimix: 3, "ccr-gas": 4 };
      var hg = Math.max.apply(null, c.g.map(function (x) { return gl[x] || 1; }));
      if (gases.indexOf("ccr-gas") >= 0) { max += W.ccr; if (c.g.indexOf("ccr-gas") >= 0) s += W.ccr; }
      else {
        max += W.gas;
        var wg = Math.max.apply(null, gases.map(function (g) { return gl[g] || 1; }));
        if (hg >= wg) s += W.gas; else if (hg >= wg - 1) s += W.gas_teil;
      }
    }
    max += W.airInt;
    if (a.airInt === "no" || c.ai) s += W.airInt; else if (a.airInt === "nice") s += W.airInt_nice;
    max += W.battery;
    if (a.battery === "any" || c.bat === a.battery) s += W.battery;
    max += W.connect;
    var wc = a.connect === "high" ? 3 : a.connect === "mid" ? 2 : 1;
    if (c.co >= wc) s += W.connect; else if (c.co >= wc - 1) s += W.connect_teil;
    if (a.compass === "yes") { max += W.compass; if (c.compass) s += W.compass; }
    if (a.gps === "yes") { max += W.gps; if (c.gps) s += W.gps; }
    max += W.logbook;
    var wl = a.logbook === "power" ? 3 : a.logbook === "casual" ? 2 : 1;
    if (c.lb >= wl) s += W.logbook; else if (c.lb >= wl - 1) s += W.logbook_teil;
    max += W.upd;
    var wu = a.upd === "current" ? 3 : a.upd === "regular" ? 2 : 1, cu = c.upd || 2;
    if (cu >= wu) s += W.upd; else if (cu >= wu - 1) s += W.upd_teil;
    if (a.fmt && a.fmt !== "any") {
      if (a.fmt === "console") { max += W.console; if (cFmt === "console") s += W.console; }
      else if (cFmt === "console") max += W.console;
      else { max += W.fmt; s += cFmt === a.fmt ? W.fmt : W.fmt_teil; }
    }
    return max > 0 ? Math.round((s / max) * 100) : 0;
  }

  function gewichte(aw) {
    var W = {}, G = {}, k;
    aw = aw || {};
    for (k in STD_GEWICHTE) W[k] = num((aw.gewichte || {})[k], STD_GEWICHTE[k]);
    for (k in STD_GRENZEN) G[k] = num((aw.budget_grenzen || {})[k], STD_GRENZEN[k]);
    return { W: W, G: G };
  }

  w.fpFinder = { STD_GEWICHTE: STD_GEWICHTE, STD_GRENZEN: STD_GRENZEN, score: fpScore, budgetOk: fpBudgetOk, gewichte: gewichte };

  // ------------------------------------------------------------------ Daten aus der Seite lesen

  function fnv(str) {               // FNV-1a 32 Bit über die UTF-16-Codeeinheiten – gleiche Rechnung wie im Backend
    var h = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return ("0000000" + h.toString(16)).slice(-8);
  }

  function lesen() {
    var metaEl = document.getElementById("fp-finder-meta");
    if (!metaEl) return null;
    var meta = JSON.parse(metaEl.textContent);
    var els = Array.prototype.slice.call(document.querySelectorAll("script.fp-finder-teil"));
    els.sort(function (x, y) { return Number(x.getAttribute("data-i")) - Number(y.getAttribute("data-i")); });
    var teile = els.slice(0, meta.teile).map(function (e) { return JSON.parse(e.textContent); });
    if (teile.length !== meta.teile) throw new Error("Teile fehlen (" + teile.length + "/" + meta.teile + ")");
    var b64 = teile.join("");
    if (b64.length !== meta.laenge) throw new Error("Länge stimmt nicht");
    var bin = atob(b64), bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    var txt = new TextDecoder("utf-8").decode(bytes);
    if (fnv(txt) !== meta.hash) throw new Error("Prüfsumme stimmt nicht");
    return { meta: meta, daten: JSON.parse(txt) };
  }

  // ------------------------------------------------------------------ Anwenden

  var MODELL_PFLICHT = ["id", "n", "b", "p", "s", "d", "g", "bat", "co", "lb", "fmt"];

  function modelleOk(arr) {
    if (!Array.isArray(arr) || arr.length < 5) return false;
    return arr.every(function (c) {
      return c && MODELL_PFLICHT.every(function (k) { return c[k] !== undefined && c[k] !== null; }) &&
        Array.isArray(c.s) && Array.isArray(c.g) && c.g.length > 0 && typeof c.p === "number";
    });
  }

  function parameter(fn) {          // "(s,t)=>…" / "n=>…" / "function(a,b){…}" → ["s","t"]
    var src = String(fn), m = src.match(/^\s*(?:async\s*)?(?:function[^(]*)?\(([^)]*)\)/) || src.match(/^\s*([\w$]+)\s*=>/);
    return m ? m[1].split(",").map(function (p) { return p.trim(); }).filter(Boolean) : [];
  }

  function alsFunktion(orig, vorlage) {
    var ps = parameter(orig);
    return function () {
      var args = arguments;
      return String(vorlage).replace(/\{(\w+)\}/g, function (all, p) { var i = ps.indexOf(p); return i >= 0 ? String(args[i]) : all; });
    };
  }

  // Neue Texte in ein bestehendes Sprachobjekt mischen; Struktur (Schlüssel, Funktionen, Antwortwerte) bleibt die von finder2.js.
  function mischen(ziel, neu) {
    Object.keys(neu).forEach(function (k) {
      var alt = ziel[k], v = neu[k];
      if (k === "qs" && Array.isArray(alt) && Array.isArray(v)) {
        alt.forEach(function (q) {
          var nq = v.filter(function (x) { return x && x.k === q.k; })[0];
          if (!nq) return;
          ["c", "t", "h"].forEach(function (f) { if (typeof nq[f] === "string") q[f] = nq[f]; });
          (q.o || []).forEach(function (o) {
            var no = (nq.o || []).filter(function (x) { return x && x.v === o.v; })[0];
            if (!no) return;
            ["l", "d"].forEach(function (f) { if (typeof no[f] === "string") o[f] = no[f]; });
          });
        });
      } else if (typeof alt === "function" && typeof v === "string") {
        ziel[k] = alsFunktion(alt, v);
      } else if (alt && typeof alt === "object" && !Array.isArray(alt) && v && typeof v === "object") {
        mischen(alt, v);
      } else if (typeof alt === "string" && typeof v === "string") {
        ziel[k] = v;
      }
    });
  }

  function anwenden(d) {
    /* global DB, DB_LIVE, T, QUESTION_IMAGES */
    if (!modelleOk(d.modelle)) throw new Error("Modellliste ungültig");
    var modelle = d.modelle.map(function (c) { var x = {}; for (var k in c) x[k] = c[k]; x.hc = !!x.cu; return x; });

    w.FINDER_DB = modelle;
    DB = modelle.map(function (c) { var x = {}; for (var k in c) x[k] = c[k]; return x; });
    DB_LIVE = DB.map(function (c) { var x = {}; for (var k in c) x[k] = c[k]; return x; });
    // Besucher: nur die veröffentlichten Daten (alte Browser-Admin-Stände im localStorage bleiben unangetastet,
    // fließen aber nicht mehr in die Anzeige ein).
    w.loadLiveDB = function () { DB_LIVE = DB.map(function (c) { var x = {}; for (var k in c) x[k] = c[k]; return x; }); return Promise.resolve(); };

    if (d.texte && typeof T === "object") {
      Object.keys(d.texte).forEach(function (l) { if (T[l] && d.texte[l]) mischen(T[l], d.texte[l]); });
    }
    if (d.bilder && typeof QUESTION_IMAGES === "object") {
      Object.keys(QUESTION_IMAGES).forEach(function (k) {
        var u = d.bilder[k];
        if (typeof u === "string" && (u === "" || /^https:\/\//.test(u))) QUESTION_IMAGES[k] = u;
      });
    }
    var g = gewichte(d.auswertung);
    w.budgetOk = function (c, b) { return fpBudgetOk(c, b, g.G); };
    w.score = function (c) { /* global answers */ return fpScore(c, answers, g.W, g.G); };
  }

  if (typeof DB === "undefined") return;   // nur auf der Finder-Seite (im Backend wird nur fpFinder gebraucht)
  try {
    var r = lesen();
    if (!r) return;
    anwenden(r.daten);
    w.FINDER_NAS = { ok: true, version: r.meta.v, modelle: r.daten.modelle.length };
  } catch (e) {
    w.FINDER_NAS = { ok: false, fehler: String(e && e.message || e) };
    if (w.console) console.warn("FrescH-Finder-NAS: Daten nicht übernommen, Seite nutzt finder2-db.js –", e);
  }
})(window);
